import React from 'react';
import { Card } from 'antd';
import TextBoxMultipleIcon from 'mdi-react/TextBoxMultipleIcon';
import './Bulas.scss';

const Bulas = (): JSX.Element => {
  return (
    <Card
      style={{ width: 150, height: 150 }}
      hoverable
      onClick={
        (): void => {
          window.open('http://agrofit.agricultura.gov.br/agrofit_cons/principal_agrofit_cons', '_blank');
        }
      }
      className="Bulas"
    >
      <TextBoxMultipleIcon size={80} className="Bulas__icon" />
      <Card.Meta title="Bulas" className="Bulas__title" />
    </Card>
  );
};

Bulas.propTypes = {};
Bulas.defaultProps = {};

export default Bulas;
